import Link from "next/link";

import clsx from "clsx";

import { ClickServer } from "shared-lib/clickserver";
import * as gtag from "shared-lib/gtag";
import {
  TRACKING_EVENTS,
  logStatsig,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";

import SymbolizedElement from "shared-components/components/SymbolizedElement";

import RecipeImage from "@/components/recipe/image";
import { getHoverGridVariant } from "@/lib/helpers/brandFunctions";
import { getRecipeLink } from "@/lib/helpers/frontendFunctions";

export default function RecipeGridItem({
  className = "",
  recipe = {} as Recipe,
  index = 0,
  priority = false,
  hideCategory = false,
  onClick = () => {
    return;
  },
  exploreMore = false,
}) {
  const hoverGridVariant = getHoverGridVariant();

  return (
    <Link
      href={getRecipeLink(recipe)}
      onClick={() => {
        onClick();

        if (exploreMore) {
          gtag.event({
            action: TRACKING_EVENTS.explore_more_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });

          logStatsig(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "recipe",
          });
          ClickServer.track(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "recipe",
          });
        } else {
          gtag.event({
            action: TRACKING_EVENTS.recipe_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });

          logStatsig(TRACKING_EVENTS.recipe_tile_click, {
            index: index.toString(),
          });
          ClickServer.track(TRACKING_EVENTS.recipe_tile_click, {
            index: index.toString(),
          });
        }
      }}
      className={clsx(
        className,
        "group block w-full rounded-md p-2 transition-colors duration-200",
        hoverGridVariant === "image_zoom_background_color" &&
          "hover:bg-gray-200",
      )}
    >
      <RecipeImage
        priority={priority}
        recipe={recipe}
        size="small"
        className="mx-auto h-64 md:h-24"
      />

      {!hideCategory && (
        <div className="mt-1 text-xs uppercase tracking-widest text-theme-gray-300">
          {recipe.category?.name}
        </div>
      )}

      <div
        className={clsx(
          "w-full pt-1 text-lg leading-8 text-theme-primary-dark transition-colors duration-300 group-hover:text-blue-500 group-hover:underline",
        )}
      >
        <SymbolizedElement title={recipe.title} />
      </div>
    </Link>
  );
}
